import { createContext, useContext } from 'react';
import { usePageTransition } from './usePageTransition';

const TransitionContext = createContext(null);

export function TransitionProvider({ children }) {
  const transition = usePageTransition();
  return (
    <TransitionContext.Provider value={transition}>
      {children}
    </TransitionContext.Provider>
  );
}

export function useTransition() {
  return useContext(TransitionContext);
}
